import React from "react"
import {Box, CircularProgress} from "@mui/material"
import {Logo} from "./Logo"

const LOGO_WIDTH = "300px"
const LOGO_HEIGHT = "122px"

export const LoadingScreen = ({tid}) => (
    <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
            minHeight: "100vh",
        }}
    >
        <Logo
            tid={tid}
            width={LOGO_WIDTH}
            height={LOGO_HEIGHT}
        />
        <CircularProgress />
    </Box>
)
